import React, { useEffect, useState } from "react";
import EditableField from "./EditableField";
import { MetadataElement, MetadataElementList, TableData } from "./SingleUploadModel";
import { CoreButton } from "@komodo-design-system/komodo-components-react";
import './SingleUploadContent.scss';
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import { AnyAction } from "redux";
import { singleUploadActions } from "actions/singleUpload";

interface TableGroupProps {
  assetMetadata: MetadataElementList;
  tableData: TableData[];
  element: MetadataElement;

}

const TableGroup: React.FC<TableGroupProps> = ({ assetMetadata, tableData, element }) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const singleUploadPayload = useSelector((state: any) => state.singleUpload.payload);
  const relatedElements = assetMetadata.metadata_element_list?.filter(
    (el) => el.meta_table_id === element.meta_table_id && el.is_tabular === "Y"
  ) || [];
  const isFirstOccurrence = relatedElements.findIndex((el) => el.field_id === element.field_id) === 0;
  const [rows, setRows] = useState<MetadataElement[][]>([]); // State to manage table rows
  // Initialize rows with existing table data
  useEffect(() => {
    const updateRows = singleUploadPayload?.metadata_collection?.metadata_element_list.find(
      (el: MetadataElement) => el.name === element.name
    );
    let newRows: MetadataElement[][] = [];
    if (updateRows) {
      updateRows.metadata_element_list.forEach((el: MetadataElement) => {
        if (el.field_id === element.field_id && el.values && Array.isArray(el.values)) {
          // Duplicate the rows based on the values array length
          newRows = el.values.map((value: any, index: number) => {
            return (
              tableData
                ?.find((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
                ?.elements.map((field) => ({
                  ...field,
                  value: field.values?.[index] || field.value || { id: '', display_value: '' }, // Map the value from the corresponding index in values
                })) || []
            );
          });
        }
      });
    }
  
    // Push the values.length to a new array for each row
    let lengths: number[] = [];
    updateRows?.metadata_element_list.forEach((el: MetadataElement) => {
      if (el.meta_table_id === element.meta_table_id && el.values && Array.isArray(el.values)) {
        lengths.push(el.values.length);
      }
    });
  
    // Find the max length of the array
    const maxLength = Math.max(...lengths, newRows.length);
  
    // Ensure newRows has the correct number of rows only if explicitly required
    if (newRows.length < maxLength) {
      for (let i = newRows.length; i < maxLength; i++) {
        newRows.push(
          tableData
            ?.find((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
            ?.elements.map((field) => ({
              ...field,
              value: { id: '', display_value: '' }, // Add empty value for the new column
            })) || []
        );
      }
    }
  
    // Only update rows if they have changed
    setRows((prevRows) => {
      if (JSON.stringify(prevRows) !== JSON.stringify(newRows)) {
        return newRows;
      }
      return prevRows;
    });
  }, [
    tableData,
    element.category_id,
    element.meta_table_id,
    element.field_id,
    singleUploadPayload?.metadata_collection?.metadata_element_list,
    element.name,
  ]);
  // useEffect(() => {
  //   const updateRows = singleUploadPayload?.metadata_collection?.metadata_element_list.find(
  //     (el: MetadataElement) => el.name === element.name
  //   );
  //   let newRows: MetadataElement[][] = [];
  //   if (updateRows) {
  //     updateRows.metadata_element_list.forEach((el: MetadataElement) => {
  //       if (el.field_id === element.field_id && el.values && Array.isArray(el.values)) {
  //         console.log('el.values', el.values);
  //         //duplicate the rows based on the values array length
  //         newRows = el.values.map((value: any, index: number) => {
  //           return tableData
  //             ?.find((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
  //             ?.elements.map((field) => ({
  //               ...field,
  //               value: {id: '', display_value:''}, // Map the value from the corresponding index in values
  //             })) || [];
  //         });
  //       }
  //     });
  //   }
  //   console.log('updateRows', updateRows);
  //   // push the values.length to a new array for each row
  //   let lengths: number[] = [];
  //   updateRows?.metadata_element_list.forEach((el: MetadataElement) => {
  //     if (el.meta_table_id === element.meta_table_id && el.values && Array.isArray(el.values)) {
  //       lengths.push(el.values.length);
  //     }
  //   }
  //   );
  //   console.log('lengths', lengths);
  //   console.log('newRows', newRows);
  //   // find the max length of the array
  //   const maxLength = Math.max(...lengths, newRows.length);
  //   console.log('maxLength', maxLength);
  //   if (newRows.length < maxLength) {
  //     // fill the newRows with empty values
  //     for (let i = newRows.length; i <= maxLength; i++) {
  //       newRows.push(
  //         tableData
  //           ?.find((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
  //           ?.elements.map((field) => ({
  //             ...field,
  //             value: { id: '', display_value: '' }, // Add empty value for the new column
  //           })) || []
  //       );
  //     }
  //   }
  //   setRows((prevRows) => {
  //     if (JSON.stringify(prevRows) !== JSON.stringify(newRows)) {
  //       return newRows;
  //     }
  //     return prevRows;
  //   });
  //   // setRows(newRows);
  // }, [tableData, element.category_id, element.meta_table_id, element.field_id, singleUploadPayload?.metadata_collection?.metadata_element_list, element.name]);

  //based on the tableData, set the rows


  // Function to add a new row
  const handleAddRow = () => {
    const newRow: MetadataElement[] = tableData
      ?.find((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
      ?.elements.map((field) => ({
        ...field,
        value: field.value as MetadataElement["value"], // Ensure the value matches the MetadataElement type
      })) || [];
    setRows((prevRows) => [...prevRows, newRow]);
  };



  const handleRemoveRow = (index: number) => {

    const updatedPayload = singleUploadPayload.metadata_collection.metadata_element_list.find(
      (el: MetadataElement) => el.name === element.name
    );
    // remove the row with same meta_table_id 
    if (updatedPayload) {
      // Update the specific field's value
      updatedPayload.metadata_element_list.forEach((el: MetadataElement) => {
        if (el.meta_table_id === element.meta_table_id) {
          // Remove the value at the specified index
          if (el.values && Array.isArray(el.values) && el.values[index]) {
            el.values.splice(index, 1); // Remove the value at the specified index
          }
        }
      });

      // Dispatch the updated payload to the Redux store
      const updatedSingleUploadPayload = {
        ...singleUploadPayload,
        metadata_collection: {
          ...singleUploadPayload.metadata_collection,
          metadata_element_list: singleUploadPayload.metadata_collection.metadata_element_list.map(
            (el: MetadataElementList) => (el.name === updatedPayload.name ? updatedPayload : el)
          ),
        },
      };

      dispatch(singleUploadActions.updateSingleUploadPayload(updatedSingleUploadPayload));
    }
    setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));
  };

  if (!isFirstOccurrence) {
    return <div className="hidden"></div>; // Use React to manage the hidden state
  }


  return (
    <>
      {tableData
        ?.filter((table) => table.name === element.category_id && table.meta_table_id === element.meta_table_id)
        .map((table) => (
          <>
            <div key={table.name} className='table-group'>
              <table>
                <thead>
                  <tr>
                    {table.elements.map((field: MetadataElement) => (
                      <>
                        <th key={field.field_id} className={field.is_required === 'Y' ? 'required-field' : ''}>{field.prompt}</th>
                      </>
                    ))}
                    <th style={{ minWidth: "73px" }}>Remove</th>
                  </tr>
                </thead>
                <tbody>

                  {rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((value: MetadataElement) => (
                        <td key={value.field_id}>
                          <EditableField element={value} rowIndex={rowIndex} />
                        </td>
                      ))}
                      <td style={{ minWidth: '73px' }}><span className={`icon-16-close-mono ${rowIndex=== 0 ? 'remove-disabled':'' }`} onClick={() => handleRemoveRow(rowIndex)}></span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <CoreButton
              variant="primary"
              size="small"
              onClick={handleAddRow}
              className="add-row-button"
              data-testid="add-row-button"
              label="Add Row"
            >
            </CoreButton>
          </>
        ))}
    </>
  );
};

export default TableGroup;
